import config from './config';
import state from './state';
import wsCode from './wsCode';
import peripheral from './peripheral';
import deviceType from './deviceType';
import runmode from './runmode';

export default {
  ADMIN_TOKEN: 'ADMIN_TOKEN', // session存储的token的key
  CHART_COLOR: [
    '#5b88ff',
    '#59c4e6',
    '#7d82d6',
    '#20edd2',
    '#93b7e3',
    '#7a17c7',
    '#96c6cc',
    '#7094e8'
  ], // 图表线条颜色
  ...config,
  ...state,
  ...wsCode,
  ...peripheral,
  ...deviceType,
  ...runmode
};
